import {Form, Formik} from "formik";
import Button from "../../../components/Button";
import {TwoFactorAuthChallengeData} from "../../../types/AuthCredentials";
import * as Yup from "yup";
import Link from "../../../components/Link";
import {TextField} from "../../../components/Form/Form";
import {useLocation, useNavigate} from "react-router-dom";
import LocationState from "../../../types/LocationState";

// Types ----

type TwoFactorAuthChallengeFormProps = {
  onSubmit: ({code}: TwoFactorAuthChallengeData) => void
  onChange: () => void
}

// Component ----

const validationSchema = Yup.object().shape({
  code: Yup.string()
    .matches(/\d{6}/, 'Must be 6 digits.')
    .required('A verification code is required.'),
});

const initialValues: TwoFactorAuthChallengeData = {
  code: '',
}

function TwoFactorAuthChallengeForm({onSubmit, onChange}: TwoFactorAuthChallengeFormProps) {
  const navigate = useNavigate();
  const location = useLocation();

  const state = location.state as LocationState;

  return (
    <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
      {formik => (
        <Form className="space-y-6" onChange={onChange}>
          <div>
            <TextField
              id="code"
              name="code"
              label="Enter your verification code"
              maxLength={6}
              autoComplete='off'
              className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-brand focus:border-brand sm:text-sm"
            />

            <div className='mt-3 text-sm'>
              <Link
                to={'/two-factor-recovery'}
                state={state}
              >
                I want to use a recovery code
              </Link>
            </div>
          </div>

          <div className='flex gap-3'>
            <Button
              type="button"
              disabled={formik.isSubmitting}
              color={Button.colors.WHITE}
              onClick={() => navigate('/login', {replace: true})}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              disabled={formik.isSubmitting}
              showSpinner={formik.isSubmitting}
            >
              Sign in
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
}

export {TwoFactorAuthChallengeForm};